// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"e53fbfe2","171":"520b5b70","363":"4b8fb87e","416":"9ed2618b","453":"7b9d5e78"}[chunkId] + ".chunk.js";
};